import users from '../components/users/usersSlice';
import prescriptions from '../components/drugs/prescriptionsSlice';
import {configureStore} from "@reduxjs/toolkit";
import auth from "./auth/auth.slice"

const stringMiddleware = () => (next) => (action) => {
    if(typeof action === 'string'){
        return next({
            type: action
        })
    }

    return next(action);
}

const store = configureStore({
    reducer: {auth, users, prescriptions},
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(stringMiddleware)
})

export default store;